import { listEmptyStateIntlIds } from './list-empty-state.ids';

export const listEmptyStateLangEsMx = {
  [listEmptyStateIntlIds.title]: `{status, select,
    assigned {¡Ups! Aún no hay vacantes reservadas o asignadas}
    not_assigned {¡Ups! No hay vacantes por aquí en este momento}
    other {}
  }`,
  [listEmptyStateIntlIds.description]: `{status, select,
    assigned {En cuanto una persona Rider reserve o sea asignada a una vacante, aparecerá aquí, ¿vale?}
    not_assigned {Cuando se creen nuevas vacantes para este hub, aparecerán aquí, ¿vale?}
    other {}
  }`,

  [listEmptyStateIntlIds.filteredList.title]:
    '¡Ups! No encontramos ninguna vacante con los filtros aplicados',
  [listEmptyStateIntlIds.filteredList.description]:
    'Revisa los filtros aplicados o límpialos e intenta de nuevo',
  [listEmptyStateIntlIds.filteredList.clearFiltersButton.label]:
    'Limpiar búsqueda',
};
